module.exports = __webpack_public_path__ + "static/media/teamwork.8c795ad5.svg";